import { headerMessages as messages } from "src/domain/TopNav/TopNav.messages";
import type { MobileTabs } from "src/App";
import { useNavigateToHotelsPage } from "./useNavigateToHotelsPage";
import { useNavigateToTrips } from "./useNavigateToTrips";
import type { TabKind } from "./useTabKind";

export function useNavigateTabs() {
  const { hotelsHash } = useNavigateToHotelsPage();
  const { tripsHash } = useNavigateToTrips();

  const tabs: Record<
    TabKind,
    {
      message: { id: string; description: string; defaultMessage: string };
      hash?: string;
      highlightedTab: MobileTabs;
    }
  > = {
    transport: {
      message: messages.transport,
      hash: "",
      highlightedTab: "search",
    },
    trips: {
      message: messages.trips,
      hash: tripsHash,
      highlightedTab: "trips",
    },
    hotels: {
      message: messages.hotels,
      hash: hotelsHash,
      highlightedTab: "hotels",
    },
  };

  return { tabs };
}
